import axios from 'axios';

type Props = {
    accountId: string;
    eventCode: string;
    rotaryCd: string;
}

/**
 * 受付するイベントの参加状況を取得する
 */
export async function getReceptionStatus({ accountId, eventCode, rotaryCd }: Props) {
    try {
        const response = await axios.get(process.env.REACT_APP_PATH + `/users/me/event/attendance`, {
            params: {
                rotaryCd: rotaryCd,
                accountId: accountId,
                eventCode: eventCode
            }
        })
        return JSON.parse(JSON.stringify(response.data))[0];
    }catch(error){
        throw error;
    }
}